import { FunctionComponent, useCallback } from 'react'
import styled, { css } from 'styled-components'
import Blink from '@components/Blink'
import sporttipSlogan from '@assets/images/sporttip/sporttip-slogan.svg'
import sporttipLiveLogo from '@assets/images/sporttip/sporttip-live-logo.svg'
import useTracking from '@hooks/useTracking'
import useViewportTracking from '@hooks/useViewportTracking'
import { mobileCSS } from '@measures/responsive'
import config from '@config'

const {
  sports: { sporttipLiveUrl },
} = config

const StyledSporttip = styled(Blink)`
  ${({
    theme: {
      colors: {
        page: { inverted },
      },
    },
  }) => css`
    width: 100%;
    height: 64px;
    background-color: ${inverted};
    display: grid;
    align-items: center;
    justify-items: center;
    position: relative;
  `}
`

const StyledLogo = styled.img`
  width: auto;
  height: 24px;
  position: absolute;
  bottom: 6px;
  right: 6px;

  ${mobileCSS(css`
    height: 18px;
  `)}
`

const StyledSloganImg = styled.img`
  height: 40px;
  width: auto;

  ${mobileCSS(css`
    height: 30px;
  `)}
`

const Sporttip: FunctionComponent = () => {
  const onImpression = useCallback(
    () => ({
      event: 'sporttip_impression',
      eventCategory: 'sporttip_widget',
      eventAction: 'impression',
      eventLabel: 'Livescore',
    }),
    []
  )

  const onClick = useCallback(
    () => ({
      event: 'sporttip_click',
      eventCategory: 'sporttip_widget',
      eventAction: 'click',
      eventLabel: 'Livescore',
    }),
    []
  )

  const trackedOnImpression = useTracking(onImpression)
  const trackedOnClick = useTracking(onClick)

  const viewportRef = useViewportTracking({
    track: true,
    onImpression: trackedOnImpression,
  })

  const clickableProps = {
    href: sporttipLiveUrl,
    target: '_blank',
    rel: 'nofollow',
  }

  return (
    <StyledSporttip
      {...clickableProps}
      ref={viewportRef}
      onClick={trackedOnClick}
      ariaLabel="Sporttip">
      <StyledLogo
        src={sporttipLiveLogo}
        alt="Sporttip logo"
        width="300"
        height="77"
        loading="lazy"
      />
      <StyledSloganImg
        src={sporttipSlogan}
        alt="Sporttip slogan"
        width="479"
        height="79"
        loading="lazy"
      />
    </StyledSporttip>
  )
}

export default Sporttip
